import { render, staticRenderFns } from "./TableColumnDriverAlerts.vue?vue&type=template&id=70b1ee3b&"
import script from "./TableColumnDriverAlerts.vue?vue&type=script&lang=js&"
export * from "./TableColumnDriverAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports